var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _g3, _path38, _path39, _path40, _g4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g5, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g6, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 674,
    viewBox: "0 0 674 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.354 586.811C167.354 586.811 237.653 623.356 317.993 584.83C398.334 546.304 424.485 471.598 466.112 415.548C487.949 386.175 523.671 369.81 550.928 345.115C638.062 266.136 606.6 134.099 526.906 97.8648C457.875 66.4969 378.141 77.7392 279.346 130.837C180.551 183.935 109.363 218.214 57.4923 324.032C5.62128 429.85 79.95 535.601 167.354 586.811Z",
    fill: "#F9A200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M167.354 586.811C167.354 586.811 237.653 623.356 317.993 584.83C398.334 546.304 424.485 471.598 466.112 415.548C487.949 386.175 523.671 369.81 550.928 345.115C638.062 266.136 606.6 134.099 526.906 97.8648C457.875 66.4969 378.141 77.7392 279.346 130.837C180.551 183.935 109.363 218.214 57.4923 324.032C5.62128 429.85 79.95 535.601 167.354 586.811Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.418 496.415H592.729",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.418 393.549H592.729",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.418 290.683H592.729",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.418 187.817H592.729",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.949 129.408V496.657",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M499.515 129.408V496.657",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.081 265.543L181.037 269.802",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.95 192.912L189.947 260.407",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M257.94 203.898L221.989 240.847",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M513.494 265.543L509.45 269.802",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M582.349 192.912L518.36 260.407",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M586.353 203.898L550.402 240.847",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2759 473.269L37.2319 477.529",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.132 400.626L46.1421 468.133",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.136 411.612L78.1709 448.574",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1985 177.666L90.168 181.926",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.068 105.023L99.0781 172.517",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M167.058 116.009L131.106 152.958",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M393.454 177.666L389.424 181.926",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M462.324 105.023L398.334 172.517",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M466.314 116.009L430.363 152.958",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M300.928 372.399L296.884 376.658",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M369.784 299.768L305.794 367.263",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M373.787 310.754L337.836 347.703",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M576.836 572.428C576.836 572.428 543.46 501.308 550.712 499.259C557.964 497.21 573.17 508.533 573.17 508.533C573.17 508.533 528.551 388.965 540.103 379.691C551.656 370.417 573.223 417.88 573.223 417.88C573.223 417.88 550.186 344.643 552.896 316.78C555.605 288.917 584.87 315.756 584.87 315.756C584.87 315.756 561.429 215.774 583.199 210.612C604.969 205.449 604.241 325.016 604.241 325.016C604.241 325.016 611.385 239.459 620.107 263.17C628.828 286.881 610.496 366.238 610.496 366.238C610.496 366.238 622.452 339.44 629.098 364.176C635.744 388.911 615.888 488.893 615.888 488.893C615.888 488.893 632.765 472.407 634.342 493.017C635.919 513.628 599.402 577.537 599.402 577.537L578.737 579.64L576.836 572.428Z",
    fill: "#F9A200"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M576.836 572.428C576.836 572.428 543.46 501.308 550.712 499.259C557.964 497.21 573.17 508.533 573.17 508.533C573.17 508.533 528.551 388.965 540.103 379.691C551.656 370.417 573.223 417.88 573.223 417.88C573.223 417.88 550.186 344.643 552.896 316.78C555.605 288.917 584.87 315.756 584.87 315.756C584.87 315.756 561.429 215.774 583.199 210.612C604.969 205.449 604.241 325.016 604.241 325.016C604.241 325.016 611.385 239.459 620.107 263.17C628.828 286.881 610.496 366.238 610.496 366.238C610.496 366.238 622.452 339.44 629.098 364.176C635.744 388.911 615.888 488.893 615.888 488.893C615.888 488.893 632.765 472.407 634.342 493.017C635.919 513.628 599.402 577.537 599.402 577.537L578.737 579.64L576.836 572.428Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M583.967 575.596C583.967 575.596 556.144 526.124 561.294 516.837C566.443 507.549 581.905 529.211 581.905 529.211C581.905 529.211 546.857 441.591 552.02 433.355C557.182 425.119 573.668 461.191 573.668 461.191C573.668 461.191 567.481 340.599 577.78 344.711C588.079 348.822 589.076 406.489 589.076 406.489C589.076 406.489 582.902 269.411 592.176 273.536C601.451 277.661 600.426 430.201 600.426 430.201C600.426 430.201 618.975 371.441 622.062 398.24C625.149 425.038 598.364 497.196 598.364 497.196C598.364 497.196 624.124 440.499 627.265 470.452C630.406 500.405 606.6 555.942 606.6 555.942C606.6 555.942 615.874 533.269 615.874 545.63C615.874 557.991 608.663 573.466 608.663 573.466",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M507.414 422.247L544.956 504.179L521.339 510.838L493.489 476.167L507.414 422.247Z",
    fill: "#F9A200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_12208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 493,
    y: 422,
    width: 52,
    height: 89
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M507.414 422.247L544.956 504.179L521.339 510.838L493.489 476.167L507.414 422.247Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_12208)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.634 448.48L499.043 454.667L530.222 508.331L534.698 507.077L500.634 448.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.514 510.798L526.017 509.531L497.008 462.526L495.458 468.551L521.514 510.798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.489 433.557L502.845 439.947L538.648 505.958L543.069 504.705L504.489 433.557Z",
    fill: "black"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M507.414 422.247L544.956 504.179L521.339 510.838L493.489 476.167L507.414 422.247Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M432.748 399.426L383.856 421.951L409.927 527.729L401.623 572.226H494.379L485.199 523.873L507.711 422.248L456.446 401.205L432.748 399.426Z",
    fill: "#F9A200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_50_12208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 399,
    width: 125,
    height: 174
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M432.748 399.426L383.856 421.951L409.927 527.729L401.623 572.226H494.379L485.199 523.873L507.711 422.248L456.446 401.205L432.748 399.426Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_50_12208)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.193 572.226L435.067 530.088C435.087 529.89 435.087 529.692 435.067 529.494L415.858 407.217L410.196 409.819L429.068 530.128L427.195 572.226H433.193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.435 520.004C444.435 520.004 444.435 519.897 444.435 519.843L429.203 401.057L423.501 403.753L438.464 520.584L442.319 572.293H448.331L444.435 520.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.235 572.226L421.627 531.098C421.674 530.795 421.674 530.486 421.627 530.182L401.07 414.052L395.449 416.64L415.669 530.775L410.277 572.226H416.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.581 421.371L499.933 419.053L479.322 525.639C479.261 525.987 479.261 526.343 479.322 526.691L486.736 572.226H492.815L485.28 526.259L485.455 525.383L485.159 523.873L489.675 503.532L505.581 421.371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.553 411.531L445.568 411.706L450.542 572.226H456.527L451.553 411.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.568 525.477L492.478 415.993L486.817 413.661L466.597 524.925C466.53 525.267 466.53 525.62 466.597 525.963L474.496 572.226H480.576L472.568 525.477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.69 521.757L476.828 409.563L471.099 407.217L455.705 521.326C455.672 521.567 455.672 521.812 455.705 522.053L461.286 572.226H467.311L461.69 521.757Z",
    fill: "black"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M432.748 399.426L383.856 421.951L409.927 527.729L401.623 572.226H494.379L485.199 523.873L507.711 422.248L456.446 401.205L432.748 399.426Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M383.857 421.951L345.344 505.352L369.932 510.541L397.781 475.871L383.857 421.951Z",
    fill: "#F9A200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_50_12208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 345,
    y: 421,
    width: 53,
    height: 90
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M383.857 421.951L345.344 505.352L369.932 510.541L397.781 475.871L383.857 421.951Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_50_12208)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.98 461.151L367.155 509.962L369.932 510.542L376.348 502.548L395.611 467.5L393.98 461.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.567 451.823L389.815 445.029L359.875 508.425L364.391 509.382L391.567 451.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.103 506.349L354.618 507.306L387.739 436.981L385.973 430.16L350.103 506.349Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.845 435.835L396.433 472.299L382.792 451.418",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M383.857 421.951L345.344 505.352L369.932 510.542L397.781 475.871L383.857 421.951Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M371.698 498.1L420.293 553.516L410.857 564.178L349.617 515.408C349.617 515.408 341.219 511.364 346.261 503.141",
    fill: "#F9A200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_50_12208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 344,
    y: 498,
    width: 77,
    height: 67
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M371.698 498.1L420.293 553.516L410.857 564.178L349.617 515.408C349.617 515.408 341.219 511.364 346.261 503.141",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_50_12208)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.197 557.371L419.754 553.475L395.247 524.952L371.697 498.099L365.362 499.353L415.197 557.371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.492 559.932L409.549 563.167L413.364 559.811L360.954 500.229L354.16 501.564L405.492 559.932Z",
    fill: "black"
  })))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M371.698 498.1L420.293 553.516L410.857 564.178L349.617 515.408C349.617 515.408 341.219 511.364 346.261 503.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M412.488 551.426C413.836 550.672 437.278 545.064 437.602 547.935C437.925 550.806 444.908 553.974 448.089 553.974C451.27 553.974 454.452 551.426 455.085 555.241C455.719 559.056 452.227 559.38 449.37 559.69C446.512 560 436.645 556.832 436.645 556.832C436.645 556.832 427.424 564.462 423.609 566.362C419.795 568.263 412.825 567.71 410.264 565.729C407.703 563.747 404.239 555.875 412.488 551.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M434.124 547.611C434.124 547.611 443.02 545.064 444.908 546.021C446.795 546.978 447.779 566.052 447.779 566.052C447.779 566.052 446.822 567.953 444.908 566.052C442.993 564.151 436.644 549.876 436.644 549.876",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M434.124 547.611C434.124 547.611 443.02 545.064 444.908 546.021C446.795 546.978 447.779 566.052 447.779 566.052C447.779 566.052 446.822 567.953 444.908 566.052C442.993 564.151 436.644 549.876 436.644 549.876",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M429.662 548.245C429.662 548.245 438.882 546.021 440.796 549.512C442.71 553.004 447.469 568.586 443.654 569.233C439.839 569.88 438.572 564.772 438.572 564.772L432.533 553.651L428.395 553.017",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M429.662 548.245C429.662 548.245 438.882 546.021 440.796 549.512C442.71 553.004 447.469 568.586 443.654 569.233C439.839 569.88 438.572 564.772 438.572 564.772L432.533 553.651L428.395 553.017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M426.494 551.103C426.494 551.103 430.943 549.202 433.167 550.793C435.391 552.383 445.568 568.586 443.654 569.233C441.74 569.88 437.292 569.544 436.658 568.276C436.024 567.009 427.761 556.144 427.761 556.144",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M426.494 551.103C426.494 551.103 430.943 549.202 433.167 550.793C435.391 552.383 445.568 568.586 443.654 569.233C441.74 569.88 437.292 569.544 436.658 568.276C436.024 567.009 427.761 556.144 427.761 556.144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M423.272 556.508C423.272 556.508 427.397 552.693 429.621 553.974C431.845 555.255 441.066 567.319 439.165 568.586C437.264 569.854 435.984 568.586 434.083 566.052C432.72 564.343 431.112 562.844 429.311 561.604L425.496 562.871",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M423.272 556.508C423.272 556.508 427.397 552.693 429.621 553.974C431.845 555.255 441.066 567.319 439.165 568.586C437.264 569.854 435.984 568.586 434.083 566.052C432.72 564.343 431.112 562.844 429.311 561.604L425.496 562.871",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M517.201 499.879L501.025 554.918L512.726 563.087L539.16 520.598C539.16 520.598 550.025 508.331 543.204 501.429",
    fill: "#F9A200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_50_12208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 501,
    y: 499,
    width: 45,
    height: 65
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M517.201 499.879L501.025 554.918L512.726 563.087L539.16 520.598C539.16 520.598 550.025 508.331 543.204 501.429",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_50_12208)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.09 562.426L513.292 562.089L535.682 500.984L529.427 500.607L507.792 559.676L510.218 561.361L513.09 562.426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.052 554.958L506.134 558.517L527.028 500.634L526.448 500.432L520.854 500.095L501.052 554.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.05 504.651C544.692 503.434 544.034 502.326 543.136 501.429L539.928 501.24L523.024 546.52L539.092 520.665L545.05 504.651Z",
    fill: "black"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M517.201 499.879L501.025 554.918L512.726 563.087L539.16 520.598C539.16 520.598 550.025 508.331 543.204 501.429",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M509.167 551.426C507.819 550.672 484.364 545.064 484.053 547.935C483.743 550.806 476.734 553.974 473.566 553.974C470.398 553.974 467.203 551.426 466.57 555.241C465.936 559.056 469.428 559.38 472.285 559.69C475.143 560 485.011 556.832 485.011 556.832C485.011 556.832 494.231 564.462 498.046 566.362C501.861 568.263 508.83 567.71 511.391 565.729C513.952 563.747 517.43 555.875 509.167 551.426Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M487.545 547.611C487.545 547.611 478.648 545.064 476.761 546.021C474.873 546.978 473.903 566.052 473.903 566.052C473.903 566.052 474.86 567.953 476.761 566.052C478.661 564.151 485.037 549.876 485.037 549.876",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M487.545 547.611C487.545 547.611 478.648 545.064 476.761 546.021C474.873 546.978 473.903 566.052 473.903 566.052C473.903 566.052 474.86 567.953 476.761 566.052C478.661 564.151 485.037 549.876 485.037 549.876",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M492.02 548.245C492.02 548.245 482.813 546.021 480.899 549.512C478.985 553.004 474.159 568.586 478.041 569.233C481.923 569.88 483.123 564.772 483.123 564.772L489.162 553.651L493.301 553.017",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M492.02 548.245C492.02 548.245 482.813 546.021 480.899 549.512C478.985 553.004 474.159 568.586 478.041 569.233C481.923 569.88 483.123 564.772 483.123 564.772L489.162 553.651L493.301 553.017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M495.174 551.103C495.174 551.103 490.726 549.202 488.502 550.793C486.277 552.383 476.1 568.586 478.014 569.233C479.928 569.88 484.363 569.544 485.01 568.276C485.657 567.009 493.907 556.144 493.907 556.144",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M495.174 551.103C495.174 551.103 490.726 549.202 488.502 550.793C486.277 552.383 476.1 568.586 478.014 569.233C479.928 569.88 484.363 569.544 485.01 568.276C485.657 567.009 493.907 556.144 493.907 556.144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M498.356 556.508C498.356 556.508 494.231 552.68 492.02 554.028C489.81 555.376 480.576 567.373 482.49 568.64C484.404 569.907 485.671 568.64 487.572 566.106C488.935 564.397 490.543 562.898 492.344 561.658L496.159 562.925",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M498.356 556.508C498.356 556.508 494.231 552.68 492.02 554.028C489.81 555.376 480.576 567.373 482.49 568.64C484.404 569.907 485.671 568.64 487.572 566.106C488.935 564.397 490.543 562.898 492.344 561.658L496.159 562.925",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M436.294 393.791C436.294 393.791 428.597 396.164 425.335 400.909C422.072 405.654 425.928 442.387 425.928 442.387L450.529 428.758L476.302 445.056C476.302 445.056 473.93 407.433 471.854 402.095C469.778 396.757 456.743 390.543 452.295 391.136C447.846 391.729 436.294 393.791 436.294 393.791Z",
    fill: "#F9A200",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M432.749 373.356V407.433L449.046 451.283L462.971 406.543V373.059L432.749 373.356Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M432.708 385.595C437.308 388.823 442.793 390.551 448.412 390.543C453.549 390.547 458.582 389.098 462.93 386.364V373.059L432.708 373.396V385.595Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M448.453 382.832C441.173 382.832 434.19 379.941 429.041 374.794C423.892 369.648 420.998 362.667 420.994 355.387L416.155 316.78C416.155 308.2 419.563 299.971 425.63 293.904C431.698 287.837 439.927 284.428 448.507 284.428C457.087 284.428 465.316 287.837 471.383 293.904C477.45 299.971 480.859 308.2 480.859 316.78L475.844 355.333C475.851 358.937 475.148 362.507 473.776 365.84C472.403 369.172 470.387 372.202 467.844 374.755C465.3 377.309 462.279 379.336 458.952 380.722C455.624 382.108 452.057 382.825 448.453 382.832Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M455.503 344.818C455.503 344.818 462.499 338.955 470.857 345.277",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M442.858 344.144C440.781 342.821 438.307 342.264 435.862 342.567",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M458.212 330.826C458.212 330.826 465.667 327.214 470.183 334.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M446.188 360.401C446.188 360.401 449.356 362.882 452.065 360.401",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M443.088 365.82C443.088 365.82 449.639 369.864 453.467 365.82",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M462.256 312.736C462.256 312.736 435.189 337.728 427.64 355.939C420.091 374.151 426.858 393.171 431.023 398.644C435.189 404.117 437.763 404.885 437.763 404.885C437.763 404.885 423.447 410.358 414.079 396.042C404.71 381.727 407.042 365.578 409.914 354.389C412.785 343.201 411.989 310.39 418.5 299.458C425.011 288.526 434.38 280.451 450.003 282.271C465.626 284.091 473.944 292.166 478.891 302.316C483.838 312.466 481.492 329.653 483.056 337.202C484.62 344.751 491.387 367.397 492.95 380.931C494.514 394.465 476.06 404.103 473.148 405.411C471.169 406.243 469.053 406.7 466.907 406.759C466.907 406.759 473.148 375.526 474.456 357.557C475.763 339.588 475.844 328.912 475.844 328.912C475.844 328.912 463.564 313.518 462.256 312.736Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_50_12208",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 407,
    y: 282,
    width: 87,
    height: 125
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M462.256 312.736C462.256 312.736 435.189 337.728 427.64 355.939C420.091 374.151 426.858 393.171 431.023 398.644C435.189 404.117 437.763 404.885 437.763 404.885C437.763 404.885 423.447 410.358 414.079 396.042C404.71 381.727 407.042 365.578 409.914 354.389C412.785 343.201 411.989 310.39 418.5 299.458C425.011 288.526 434.38 280.451 450.003 282.271C465.626 284.091 473.944 292.166 478.891 302.316C483.838 312.466 481.492 329.653 483.056 337.202C484.62 344.751 491.387 367.397 492.95 380.931C494.514 394.465 476.06 404.103 473.148 405.411C471.169 406.243 469.053 406.7 466.907 406.759C466.907 406.759 473.148 375.526 474.456 357.557C475.763 339.588 475.844 328.912 475.844 328.912C475.844 328.912 463.564 313.518 462.256 312.736Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_50_12208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.089 295.212C459.089 295.212 455.894 304.014 432.911 329.236C409.927 354.457 403.686 378.518 410.669 402.028",
    stroke: "#707070",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.413 286.423C453.413 286.423 440.769 296.897 425.105 312.588C415.478 322.301 407.257 333.313 400.68 345.304",
    stroke: "#707070",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.75 297.328C464.75 297.328 474.348 314.771 479.578 325.245C484.808 335.719 490.928 394.587 472.609 415.561",
    stroke: "#707070",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.212 282.932L462.256 312.736",
    stroke: "#707070",
    strokeMiterlimit: 10
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M462.256 312.736C462.256 312.736 435.189 337.728 427.64 355.939C420.091 374.151 426.858 393.171 431.023 398.644C435.189 404.117 437.763 404.885 437.763 404.885C437.763 404.885 423.447 410.358 414.079 396.042C404.71 381.727 407.042 365.578 409.914 354.389C412.785 343.201 411.989 310.39 418.5 299.458C425.011 288.526 434.38 280.451 450.003 282.271C465.626 284.091 473.944 292.166 478.891 302.316C483.838 312.466 481.492 329.653 483.056 337.202C484.62 344.751 491.387 367.397 492.95 380.931C494.514 394.465 476.06 404.103 473.148 405.411C471.169 406.243 469.053 406.7 466.907 406.759C466.907 406.759 473.148 375.526 474.456 357.557C475.763 339.588 475.844 328.912 475.844 328.912C475.844 328.912 463.564 313.518 462.256 312.736Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M413.486 330.179H409.495C407.292 330.179 405.505 331.966 405.505 334.169V350.143C405.505 352.347 407.292 354.133 409.495 354.133H413.486C415.689 354.133 417.476 352.347 417.476 350.143V334.169C417.476 331.966 415.689 330.179 413.486 330.179Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M486.642 330.179H482.652C480.448 330.179 478.662 331.966 478.662 334.169V350.143C478.662 352.347 480.448 354.133 482.652 354.133H486.642C488.845 354.133 490.632 352.347 490.632 350.143V334.169C490.632 331.966 488.845 330.179 486.642 330.179Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M485.685 330.179V317.157C485.685 307.079 481.681 297.414 474.555 290.287C467.428 283.161 457.763 279.157 447.684 279.157C437.605 279.157 427.938 283.16 420.81 290.286C413.681 297.412 409.674 307.078 409.671 317.157V330.179",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M484.646 354.012C484.646 354.012 482.961 367.047 467.015 372.358",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M466.408 371.792C467.082 373.746 465.181 376.173 462.148 377.184C459.115 378.195 456.136 377.507 455.408 375.553C454.68 373.598 456.635 371.172 459.655 370.161C462.674 369.15 465.774 369.837 466.408 371.792Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M193.573 388.601L137.874 415.144L153.942 572.55H264.976L280.681 412.528L228.338 388.224L193.573 388.601Z",
    fill: "#F9A200",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M215.896 436.631C216.938 436.631 217.783 435.786 217.783 434.743C217.783 433.701 216.938 432.856 215.896 432.856C214.853 432.856 214.008 433.701 214.008 434.743C214.008 435.786 214.853 436.631 215.896 436.631Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M217.783 446.067C217.783 446.44 217.672 446.805 217.465 447.115C217.257 447.426 216.963 447.667 216.618 447.81C216.273 447.953 215.893 447.99 215.527 447.918C215.161 447.845 214.825 447.665 214.561 447.401C214.297 447.137 214.117 446.801 214.045 446.435C213.972 446.069 214.009 445.689 214.152 445.344C214.295 445 214.537 444.705 214.847 444.498C215.157 444.29 215.522 444.18 215.896 444.18C216.396 444.18 216.876 444.378 217.23 444.732C217.584 445.086 217.783 445.566 217.783 446.067Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M235.212 396.636L219.993 413.607L213.496 430.093L206.5 413.364L191.78 396.636V366.926H235.212V396.636Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M191.78 380.136C194.645 383.619 198.247 386.423 202.326 388.346C206.405 390.269 210.86 391.263 215.37 391.257C222.648 391.266 229.689 388.664 235.212 383.924V366.926H191.78V380.136Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M218.43 283.781H212.31C197.108 283.781 184.784 296.105 184.784 311.307V355.373C184.784 370.576 197.108 382.899 212.31 382.899H218.43C233.632 382.899 245.956 370.576 245.956 355.373V311.307C245.956 296.105 233.632 283.781 218.43 283.781Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M221.234 327.726L220.33 349.388C220.313 350.327 220.007 351.238 219.455 351.997C218.903 352.756 218.131 353.328 217.244 353.634C215.612 354.133 213.752 353.634 212.741 349.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M203.548 357.934H227.812C227.812 357.934 223.566 367.182 215.329 367.182C207.093 367.182 203.548 357.934 203.548 357.934Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M205.273 361.183H225.709C226.486 360.168 227.163 359.08 227.731 357.934H203.548C204.008 359.074 204.587 360.163 205.273 361.183Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M203.265 337.472C204.233 337.472 205.017 335.625 205.017 333.347C205.017 331.069 204.233 329.222 203.265 329.222C202.297 329.222 201.513 331.069 201.513 333.347C201.513 335.625 202.297 337.472 203.265 337.472Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M229.47 337.472C230.438 337.472 231.223 335.625 231.223 333.347C231.223 331.069 230.438 329.222 229.47 329.222C228.502 329.222 227.718 331.069 227.718 333.347C227.718 335.625 228.502 337.472 229.47 337.472Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M223.984 322.482C223.984 322.482 229.969 318.735 236.722 324.733",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M215.37 283.781C207.258 283.781 199.478 287.003 193.742 292.739C188.006 298.475 184.784 306.255 184.784 314.367V342.23H185.04H187.534V330.745C187.534 330.745 200.016 330.745 214.75 322.765C229.483 314.785 233.204 301.763 233.204 301.763C233.204 301.763 236.453 317.494 239.944 320.487L243.449 323.48V342.459H245.942V314.367C245.942 306.257 242.722 298.48 236.989 292.744C231.256 287.009 223.479 283.785 215.37 283.781Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M179.055 327.483H184.784V350.197H179.055C177.596 350.197 176.197 349.617 175.166 348.586C174.135 347.555 173.555 346.156 173.555 344.697V332.956C173.562 331.502 174.145 330.11 175.176 329.084C176.206 328.059 177.601 327.483 179.055 327.483Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M251.321 350.197H245.592V327.483H251.321C252.043 327.483 252.758 327.625 253.426 327.902C254.093 328.178 254.699 328.583 255.21 329.094C255.721 329.605 256.126 330.211 256.402 330.878C256.679 331.546 256.821 332.261 256.821 332.983V344.724C256.814 346.178 256.231 347.57 255.2 348.596C254.17 349.621 252.775 350.197 251.321 350.197Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M179.796 327.483V312.992C179.796 303.59 183.532 294.572 190.18 287.923C196.829 281.275 205.846 277.54 215.249 277.54C224.65 277.543 233.666 281.28 240.313 287.927C246.961 294.575 250.698 303.591 250.701 312.992V327.483",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M250.728 350.197C250.728 350.197 248.975 363.677 232.503 369.177",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M231.856 368.584C232.557 370.606 230.589 373.113 227.462 374.205C224.334 375.297 221.234 374.528 220.533 372.506C219.832 370.484 221.8 367.977 224.927 366.885C228.055 365.793 231.195 366.562 231.856 368.584Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M137.873 415.144L90.7607 514.828L110.199 531.786L145.341 487.679L137.873 415.144Z",
    fill: "#F9A200",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M134.005 445.703L145.449 484.309L131.861 462.135",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M280.681 412.528L325.542 512.725L297.881 524.696L273.199 485.064L280.681 412.528Z",
    fill: "#F9A200",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M116.184 512.348L156.557 550.105L145.341 563.194L86.6494 526.785L93.3894 508.843",
    fill: "#F9A200"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M116.184 512.348L156.557 550.105L145.341 563.194L86.6494 526.785L93.3894 508.843",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M149.83 547.868C151.475 546.978 178.987 540.386 179.365 543.756C179.742 547.126 187.965 550.86 191.699 550.86C195.433 550.86 199.18 547.868 199.922 552.356C200.663 556.845 196.565 557.209 193.182 557.587C189.798 557.964 178.233 554.217 178.233 554.217C178.233 554.217 167.448 563.194 162.906 565.446C158.363 567.697 150.194 566.928 147.202 564.691C144.209 562.453 140.111 553.098 149.83 547.868Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M175.24 543.379C175.24 543.379 185.714 540.386 187.951 541.519C190.189 542.651 191.321 565.068 191.321 565.068C191.321 565.068 190.189 567.306 187.951 565.068C185.714 562.83 178.246 545.94 178.246 545.94",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M175.24 543.379C175.24 543.379 185.714 540.386 187.951 541.519C190.189 542.651 191.321 565.068 191.321 565.068C191.321 565.068 190.189 567.306 187.951 565.068C185.714 562.83 178.246 545.94 178.246 545.94",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M170.023 544.134C170.023 544.134 180.807 541.519 183.099 545.63C185.39 549.741 190.958 568.061 186.469 568.802C181.98 569.543 180.484 563.572 180.484 563.572L173.38 550.483L168.527 549.741",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M170.023 544.134C170.023 544.134 180.807 541.519 183.099 545.63C185.39 549.741 190.958 568.061 186.469 568.802C181.98 569.543 180.484 563.572 180.484 563.572L173.38 550.483L168.527 549.741",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M166.276 547.49C166.276 547.49 171.52 545.253 174.135 547.126C176.75 549 188.72 568.061 186.469 568.856C184.218 569.651 178.988 569.233 178.246 567.737C177.505 566.241 167.772 553.529 167.772 553.529",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M166.276 547.49C166.276 547.49 171.52 545.253 174.135 547.126C176.75 549 188.72 568.061 186.469 568.856C184.218 569.651 178.988 569.233 178.246 567.737C177.505 566.241 167.772 553.529 167.772 553.529",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M162.542 553.853C162.542 553.853 167.408 549.364 170.023 550.86C172.639 552.356 183.503 566.564 181.239 568.061C178.974 569.557 177.491 568.061 175.254 565.068C173.652 563.054 171.763 561.287 169.646 559.824L165.157 561.321",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M162.542 553.853C162.542 553.853 167.408 549.364 170.023 550.86C172.639 552.356 183.503 566.564 181.239 568.061C178.974 569.557 177.491 568.061 175.254 565.068C173.652 563.054 171.763 561.287 169.646 559.824L165.157 561.321",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M291.101 502.804L267.43 552.761L282.662 560.808L327.429 513.372L314.583 499.151",
    fill: "#F9A200"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M291.101 502.804L267.43 552.761L282.662 560.808L327.429 513.372L314.583 499.151",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M279.279 547.868C277.634 546.978 250.108 540.386 249.744 543.756C249.38 547.126 241.144 550.86 237.396 550.86C233.649 550.86 229.928 547.868 229.173 552.356C228.419 556.845 232.543 557.209 235.913 557.587C239.283 557.964 250.863 554.217 250.863 554.217C250.863 554.217 261.647 563.194 266.189 565.446C270.732 567.697 278.901 566.928 281.894 564.691C284.886 562.453 288.998 553.098 279.279 547.868Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M253.856 543.379C253.856 543.379 243.382 540.386 241.144 541.519C238.906 542.651 237.774 565.068 237.774 565.068C237.774 565.068 238.893 567.306 241.144 565.068C243.395 562.83 250.863 545.94 250.863 545.94",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M253.856 543.379C253.856 543.379 243.382 540.386 241.144 541.519C238.906 542.651 237.774 565.068 237.774 565.068C237.774 565.068 238.893 567.306 241.144 565.068C243.395 562.83 250.863 545.94 250.863 545.94",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M259.085 544.134C259.085 544.134 248.302 541.519 245.996 545.63C243.691 549.741 238.151 568.061 242.64 568.856C247.129 569.651 248.612 563.626 248.612 563.626L255.715 550.537L260.582 549.795",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.085 544.134C259.085 544.134 248.302 541.519 245.996 545.63C243.691 549.741 238.151 568.061 242.64 568.856C247.129 569.651 248.612 563.626 248.612 563.626L255.715 550.537L260.582 549.795",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M262.86 547.49C262.86 547.49 257.63 545.253 255.014 547.126C252.399 549 240.389 568.061 242.64 568.856C244.891 569.651 250.108 569.233 250.863 567.737C251.617 566.241 261.323 553.529 261.323 553.529",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M262.86 547.49C262.86 547.49 257.63 545.253 255.014 547.126C252.399 549 240.389 568.061 242.64 568.856C244.891 569.651 250.108 569.233 250.863 567.737C251.617 566.241 261.323 553.529 261.323 553.529",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M266.567 553.853C266.567 553.853 261.701 549.364 259.086 550.86C256.471 552.356 245.606 566.564 247.87 568.061C250.135 569.557 251.604 568.061 253.855 565.068C255.457 563.054 257.347 561.287 259.463 559.824L263.952 561.321",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M266.567 553.853C266.567 553.853 261.701 549.364 259.086 550.86C256.471 552.356 245.606 566.564 247.87 568.061C250.135 569.557 251.604 568.061 253.855 565.068C255.457 563.054 257.347 561.287 259.463 559.824L263.952 561.321",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M350.022 226.747H262.402C258.339 226.747 254.443 228.36 251.569 231.231C248.695 234.103 247.078 237.998 247.075 242.06V267.672C247.064 269.69 247.452 271.689 248.216 273.556C248.98 275.423 250.104 277.121 251.526 278.553C252.947 279.984 254.637 281.121 256.499 281.898C258.361 282.675 260.357 283.076 262.375 283.08H273.159L258.452 302.316L291.518 283.08H350.022C352.034 283.075 354.026 282.673 355.884 281.898C357.741 281.123 359.428 279.989 360.848 278.562C362.267 277.135 363.391 275.443 364.157 273.581C364.922 271.72 365.313 269.726 365.308 267.713V242.101C365.315 238.038 363.709 234.139 360.843 231.26C357.976 228.381 354.084 226.758 350.022 226.747Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M294.174 256.673C294.177 257.38 293.97 258.072 293.579 258.661C293.188 259.25 292.631 259.71 291.978 259.983C291.326 260.255 290.607 260.328 289.913 260.191C289.22 260.055 288.582 259.716 288.081 259.217C287.58 258.718 287.238 258.081 287.099 257.388C286.96 256.695 287.03 255.976 287.3 255.322C287.57 254.669 288.028 254.11 288.616 253.717C289.204 253.324 289.895 253.114 290.602 253.114C291.547 253.114 292.454 253.488 293.123 254.155C293.793 254.822 294.171 255.728 294.174 256.673Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M309.757 256.673C309.759 257.38 309.552 258.073 309.16 258.662C308.769 259.252 308.211 259.712 307.558 259.984C306.904 260.256 306.185 260.328 305.491 260.19C304.797 260.053 304.159 259.712 303.659 259.212C303.158 258.712 302.818 258.074 302.68 257.38C302.543 256.686 302.615 255.966 302.887 255.313C303.159 254.66 303.619 254.102 304.208 253.71C304.798 253.319 305.49 253.111 306.198 253.114C307.142 253.114 308.047 253.489 308.714 254.156C309.382 254.824 309.757 255.729 309.757 256.673Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M325.34 256.673C325.34 257.377 325.131 258.065 324.74 258.65C324.349 259.235 323.793 259.691 323.143 259.961C322.492 260.23 321.777 260.3 321.087 260.163C320.396 260.026 319.762 259.687 319.264 259.189C318.767 258.691 318.428 258.057 318.291 257.367C318.153 256.677 318.224 255.961 318.493 255.311C318.762 254.661 319.219 254.105 319.804 253.714C320.389 253.323 321.077 253.114 321.781 253.114C322.725 253.114 323.63 253.489 324.297 254.156C324.965 254.824 325.34 255.729 325.34 256.673Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M529.023 568.492H365.726V575.084H529.023V568.492Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M554.109 568.492H411.774V575.084H554.109V568.492Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M556.872 556.778H420.697L435.377 452.807H571.552L556.872 556.778Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M562.507 556.778H426.332L441.012 452.807H577.187L562.507 556.778Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M520.773 508.452L534.442 575.07H499.299L485.644 508.452H520.773ZM496.94 528.227C497.007 528.498 497.163 528.738 497.383 528.91C497.603 529.081 497.875 529.173 498.153 529.171L518.063 528.982C518.25 528.979 518.434 528.935 518.6 528.851C518.767 528.768 518.913 528.648 519.027 528.5C519.141 528.352 519.22 528.181 519.259 527.998C519.298 527.816 519.294 527.627 519.25 527.445L517.457 519.978C517.391 519.705 517.235 519.463 517.015 519.29C516.795 519.116 516.524 519.022 516.244 519.02L496.334 519.209C496.147 519.212 495.963 519.257 495.796 519.341C495.629 519.424 495.482 519.544 495.367 519.691C495.252 519.838 495.171 520.01 495.131 520.192C495.091 520.375 495.092 520.564 495.134 520.746L496.94 528.227Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M287.488 568.492H124.191V575.084H287.488V568.492Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M312.575 568.492H170.239V575.084H312.575V568.492Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M315.338 556.778H179.163L193.843 452.807H330.018L315.338 556.778Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M320.972 556.778H184.797L199.477 452.807H335.652L320.972 556.778Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M279.252 508.452L292.907 575.07H257.765L244.109 508.452H279.252ZM255.406 528.227C255.474 528.497 255.631 528.736 255.851 528.907C256.07 529.078 256.341 529.171 256.619 529.171L276.529 528.982C276.716 528.979 276.899 528.934 277.067 528.851C277.234 528.767 277.38 528.647 277.495 528.5C277.61 528.353 277.691 528.182 277.731 527.999C277.772 527.817 277.771 527.627 277.729 527.445L275.922 519.978C275.858 519.704 275.703 519.461 275.483 519.287C275.263 519.113 274.99 519.019 274.709 519.02L254.799 519.209C254.612 519.212 254.429 519.257 254.262 519.34C254.095 519.424 253.949 519.544 253.835 519.691C253.721 519.839 253.642 520.011 253.603 520.193C253.565 520.376 253.568 520.565 253.613 520.746L255.406 528.227Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBanner);
export default __webpack_public_path__ + "static/media/contact-banner.5e039468cda35206d10e7fc6cd022735.svg";
export { ForwardRef as ReactComponent };